import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-473">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-474">
        <div className="flex justify-between items-center" data-id="element-475">
          {/* Logo Area */}
          <div className="flex items-baseline gap-3" data-id="element-476">
            <a href="#home" className="text-2xl font-heading font-bold text-navy tracking-tight" data-id="element-477">
              SyNeural
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-478">
            <ul className="flex items-center gap-6" data-id="element-479">
              {/* Platform Dropdown */}
              <li className="relative" data-id="element-480">
                <button onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-481">
                  Platform
                  <ChevronDown size={14} className={`transition-transform ${platformDropdownOpen ? 'rotate-180' : ''}`} data-id="element-482" />
                </button>

                <AnimatePresence data-id="element-483">
                  {platformDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-484">
                      <a href="#cji" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-485">
                        <div className="font-semibold" data-id="element-486">CJI</div>
                        <div className="text-xs text-ink-muted" data-id="element-487">
                          Civic Judgment Index
                        </div>
                      </a>
                      <a href="#ncji" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-488">
                        <div className="font-semibold" data-id="element-489">NCJI</div>
                        <div className="text-xs text-ink-muted" data-id="element-490">
                          Neurocognitive Index
                        </div>
                      </a>
                      <div className="border-t border-line my-2" data-id="element-491"></div>
                      <a href="#solutions" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-492">
                        <div className="font-semibold" data-id="element-493">Solutions</div>
                        <div className="text-xs text-ink-muted" data-id="element-494">
                          Applications & Use Cases
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {/* Company Dropdown */}
              <li className="relative" data-id="element-495">
                <button onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-496">
                  Company
                  <ChevronDown size={14} className={`transition-transform ${companyDropdownOpen ? 'rotate-180' : ''}`} data-id="element-497" />
                </button>

                <AnimatePresence data-id="element-498">
                  {companyDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-499">
                      <a href="#about" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-500">
                        <div className="font-semibold" data-id="element-501">About</div>
                        <div className="text-xs text-ink-muted" data-id="element-502">
                          Mission & Vision
                        </div>
                      </a>
                      <a href="#research" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-503">
                        <div className="font-semibold" data-id="element-504">Research</div>
                        <div className="text-xs text-ink-muted" data-id="element-505">
                          Future Work
                        </div>
                      </a>
                      <a href="#partnerships" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-506">
                        <div className="font-semibold" data-id="element-507">Partnerships</div>
                        <div className="text-xs text-ink-muted" data-id="element-508">
                          Collaborate with Us
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {navItems.map(item => <li key={item} data-id="element-509">
                  <a href={`#${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-510">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-511"></div>
            <button className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-512">
              Request Demo
            </button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-513">
            {mobileMenuOpen ? <X size={24} data-id="element-514" /> : <Menu size={24} data-id="element-515" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-516">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-517">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-518">
              {/* Platform submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-519">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-520">
                  Platform
                </div>
                <a href="#cji" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-521">
                  CJI
                </a>
                <a href="#ncji" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-522">
                  NCJI
                </a>
                <a href="#solutions" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-523">
                  Solutions
                </a>
              </div>

              {/* Company submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-524">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-525">
                  Company
                </div>
                <a href="#about" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-526">
                  About
                </a>
                <a href="#research" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-527">
                  Research
                </a>
                <a href="#partnerships" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-528">
                  Partnerships
                </a>
              </div>

              {navItems.map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-529">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-530">
                <button className="w-full bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-531">
                  Request Demo
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}